import React from "react";
const ZIndexContext = React.createContext(null);
const ZIndexContextProvider = ({ zIndexService, children }) => /* @__PURE__ */ React.createElement(ZIndexContext.Provider, { value: zIndexService }, children);
function withZIndexContext(Component) {
  return (props) => {
    return /* @__PURE__ */ React.createElement(ZIndexContext.Consumer, null, (value) => /* @__PURE__ */ React.createElement(Component, { ...props, zIndexService: value }));
  };
}
export {
  ZIndexContext,
  ZIndexContextProvider,
  withZIndexContext
};
//# sourceMappingURL=z-index-context.js.map
